import { browserOptOut, closeConsentSettings, setConsent, useConsent, useConsentPrompt } from "../consent.ts";
import { t } from "../i18n.ts";
import { linkHandler } from "../router.ts";

/**
 * Hinweis zur Nutzungsstatistik (E-33): erscheint, bis eine Entscheidung gefallen ist, und lässt
 * sich über die Fußzeile wieder öffnen. Ablehnen und Zustimmen sind gleich groß und gleich auffällig.
 * Er blockiert das Spiel nicht und sitzt über der Aktionsleiste (--dock-h).
 */
export function ConsentBanner() {
  const show = useConsentPrompt();
  const consent = useConsent();
  if (!show) return null;
  const blocked = browserOptOut();
  return (
    <section className="consent" aria-labelledby="consent-title">
      <h2 id="consent-title">{t.consent.title}</h2>
      <p>
        {blocked ? t.consent.browserOptOut : t.consent.text}{" "}
        <a href="/datenschutz" onClick={linkHandler("/datenschutz")}>
          {t.consent.more}
        </a>
      </p>
      {!blocked && consent && <p className="consent-current">{consent === "granted" ? t.consent.currentGranted : t.consent.currentDenied}</p>}
      <div className="consent-actions">
        {blocked ? (
          <button type="button" className="btn btn-cyan" onClick={closeConsentSettings}>
            {t.consent.ok}
          </button>
        ) : (
          <>
            <button type="button" className="btn btn-cyan" onClick={() => setConsent("denied")}>
              {t.consent.deny}
            </button>
            <button type="button" className="btn btn-cyan" onClick={() => setConsent("granted")}>
              {t.consent.allow}
            </button>
          </>
        )}
      </div>
    </section>
  );
}
